import React from "react";
import PropTypes from "prop-types";

import { useManageEditImportedSyncEntity } from "./hooks";
import {
  Checkbox,
  ImportedSyncEntityModalButtons,
  ImportedSyncEntityModalHeader,
  makeStyles,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "./components";

const useStyles = makeStyles({
  table: {
    fontFamily: '"Helvetica Neue", Arial, Helvetica, sans-serif',
  },
  cell: { padding: "10px 0px" },
  lastCell: { padding: "10px 0px", borderBottom: "0px" },
  headCell: { padding: "0px", fontWeight: "bold", borderBottom: "0px" },
});

export function EditImportedSyncEntityModal({
  importedTypes,
  loading,
  onClose,
  onSubmit,
  title,
  subtitle,
  columnName,
  type,
}) {
  const { table, cell, headCell, lastCell } = useStyles();
  const { disabled, set, options, submit } = useManageEditImportedSyncEntity(
    importedTypes,
    onSubmit,
    type
  );

  return (
    <Modal data-test="edit-imported-sync-entity-modal" open size="mini">
      <Modal.Header style={{ border: 0 }}>
        <ImportedSyncEntityModalHeader title={title} subtitle={subtitle} />
      </Modal.Header>
      <Modal.Content scrolling>
        <Table className={table}>
          <TableHead>
            <TableRow>
              <TableCell className={headCell}>&nbsp;</TableCell>
              <TableCell className={headCell}>{columnName}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {options.map(({ externalId, name, isExcluded }, i) => {
              const getStyle = () => {
                return i === importedTypes.length - 1 ? lastCell : cell;
              };

              return (
                <TableRow key={externalId}>
                  <TableCell className={getStyle()}>
                    <Checkbox
                      name={externalId}
                      checked={!isExcluded}
                      onChange={set}
                    />
                  </TableCell>
                  <TableCell className={getStyle()}>{name}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Modal.Content>
      <Modal.Actions
        style={{ background: "#ffffff", border: 0, paddingBottom: "28px" }}
      >
        <ImportedSyncEntityModalButtons
          loading={loading}
          disabled={disabled}
          onClose={onClose}
          onSubmit={submit}
        />
      </Modal.Actions>
    </Modal>
  );
}

EditImportedSyncEntityModal.propTypes = {
  importedTypes: PropTypes.arrayOf(
    PropTypes.shape({
      externalId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      isExcluded: PropTypes.bool.isRequired,
    })
  ).isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  columnName: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  type: PropTypes.oneOf(["inclusion", "exclusion"]),
};

EditImportedSyncEntityModal.defaultProps = {
  loading: false,
  type: "exclusion",
};

export default EditImportedSyncEntityModal;
